import { SELECT_SUBMENU, ACTIVE_MENU, ACTIVE_MENU_PARENT } from '@app/store/constants';
import { DispatchFunction } from '@app/models';
import { IMenuItem } from '@app/components/Sidebar/menuObject';
import { Dispatch } from 'redux';

export function handleDataForSidebar(menu: IMenuItem | null | undefined): DispatchFunction {
    return ((dispatch: Dispatch) => {
        if (menu !== undefined && menu !== null) {
            dispatch(activeMenu(menu.id));
            dispatch(activeMenuParent(menu.parentId || 0));

            if (menu.parentId) {
                dispatch(selectMenu(menu.parentId));
            }
        } else if (menu !== undefined && menu === null) {
            dispatch(activeMenu(-1));
        }
    });
}

export function selectMenu(id: number) {
    return {
        payload: id,
        type: SELECT_SUBMENU
    };
}

export function activeMenu(id: number) {
    return {
        payload: id,
        type: ACTIVE_MENU
    };
}

export function activeMenuParent(id: number) {
    return {
        payload: id,
        type: ACTIVE_MENU_PARENT
    };
}
